/**
 * Basecamp brand mark (mountain logo).
 * Source: frontend/public/icons/basecamp-logo.svg
 */

import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

export const BasecampIcon = forwardRef<SVGSVGElement, LucideProps>(function BasecampIcon(
  { className, size, ...props },
  ref,
) {
  const dimension = typeof size === 'number' ? size : undefined;

  return (
    <svg
      ref={ref}
      viewBox="0 0 256 213"
      xmlns="http://www.w3.org/2000/svg"
      width={dimension}
      height={dimension ? dimension * (213 / 256) : undefined}
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden
      {...props}
    >
      <path
        d="M128.300525,0 C59.6596401,0 5.88330599,87.3292379 0.795322946,161.089363 C22.33503,198.473015 74.2776064,212.524878 128.300525,212.524878 C182.319971,212.524878 234.266021,198.473015 255.795309,161.089363 C250.707325,87.3292379 196.937937,0 128.300525,0"
        fill="#B6DEFF"
      />
      <path
        d="M237.860602,143.519325 C237.860602,143.519325 222.700844,110.744379 207.291028,91.621898 C191.870793,72.492471 173.040046,51.6612613 161.905525,51.6612613 C150.777949,51.6612613 119.670056,106.73998 105.399392,106.73998 C91.1252553,106.73998 83.7068719,81.7723964 66.1576716,81.7723964 C48.6015254,81.7723964 20.7096538,141.980775 20.7096538,141.980775 L18.8203277,152.187998 C18.8203277,152.187998 28.5100702,195.149329 129.884225,195.149329 C231.261853,195.149329 239.364423,152.893022 239.364423,152.893022 L237.860602,143.519325"
        fill="#66CC66"
      />
      <path
        d="M106.986565,130.24542 C91.2433382,130.24542 83.1720259,114.710575 78.7960131,105.12155 C74.8610747,96.4841344 74.1803616,82.8455614 63.0145831,82.4635286 C64.1120594,82.0294003 65.1678592,81.7723964 66.1576716,81.7723964 C83.7068719,81.7723964 91.1252553,106.73998 105.399392,106.73998 C119.670056,106.73998 150.777949,51.6612613 161.905525,51.6612613 C164.003232,51.6612613 166.36489,52.4010158 168.927983,53.7172926 C167.031711,53.4672348 164.600593,53.6408861 162.728632,55.5197931 C159.130577,59.117848 126.477187,130.24542 106.986565,130.24542"
        fill="#17AD49"
      />
    </svg>
  );
});

BasecampIcon.displayName = 'BasecampIcon';
